import { Injectable } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams
} from '@ngx-translate/core';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (params.key.startsWith('error_')) {
      return params.translateService.instant('popup_error_generic', {
        mainPhone: params.translateService.instant('ko_main_phone')
      });
    }
    return params.key;
  }
}
